import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Projectional Editor Framework",
description: "Overview of the internal structure of Freon’s projectional editor framework, including the AST, Box Tree, and DOM synchronization.",
tags: [ "Editor Framework", "Box Tree", "AST", "DOM", "Projection", "Freon"] ,
modifiedTime: "2025-11-07T19:11:39.226Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};